'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _next = require('@alifd/next');

var _vuFusionField = require('../common/vu-fusion-field');

var _vuFusionField2 = _interopRequireDefault(_vuFusionField);

require('./view.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var PresuffixInput = (_temp = _class = function (_Field) {
  _inherits(PresuffixInput, _Field);

  function PresuffixInput() {
    _classCallCheck(this, PresuffixInput);

    return _possibleConstructorReturn(this, _Field.apply(this, arguments));
  }

  PresuffixInput.prototype.getProps = function getProps() {
    return _extends({}, this.props, {
      fieldClassName: 'vc-pre-suffix-input'
    });
  };

  PresuffixInput.prototype.renderControl = function renderControl() {
    var commonProps = this.getControlProps();

    var _props = this.props,
        showPrefix = _props.showPrefix,
        prefix = _props.prefix,
        showSuffix = _props.showSuffix,
        suffix = _props.suffix,
        inputType = _props.inputType;


    var inputProps = _extends({}, commonProps, {
      addonTextBefore: showPrefix ? prefix : '',
      addonTextAfter: showSuffix ? suffix : '',
      htmlType: inputType ? 'password' : ''
    });
    return _react2.default.createElement(_next.Input, inputProps);
  };

  return PresuffixInput;
}(_vuFusionField2.default), _class.displayName = 'PreSuffixInput', _class.defaultProps = _extends({}, _vuFusionField2.default.defaultProps, {
  fieldId: null,
  label: null
}), _class.propTypes = {
  fieldId: _propTypes2.default.string,
  label: _propTypes2.default.string
}, _temp);
exports.default = PresuffixInput;
module.exports = exports['default'];